<template>
  <div class="wrapper-freespins">
    <p class="title-freespins">{{ $t('free_spins_popups.congratulations') }}</p>
    <div class="freespins-body">
      <p class="text-freespins text-congratulations">
        {{ $t('free_spins_popups.you_win_prize', { prize: getCurrentPrize }) }}
      </p>
      <p v-if="!isAchievementPrizeGame" class="text-freespins">
        {{ $t('free_spins_popups.receive_game', { gameName: gameName }) }}
      </p>
      <p v-if="isAchievementPrizeGame" class="text-freespins">
        {{ $t('free_spins_popups.have_prize_other_game', { gameName: gameName }) }}
      </p>
      <LogoTransition />
    </div>

    <ButtonPopup
      v-if="linkGameTournamentOrAchievement"
      :closePopup="false"
      :text="btnTransitionText"
      @getOtherGame="getOtherGame" />
    <ButtonPopup
      v-if="!linkGameTournamentOrAchievement"
      :closePopup="true"
      :text="btnCloseText"
      @closePopup="closePopup" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters } from 'vuex';
import ButtonPopup from '@/components/freeSpinsPopups/componentsPopup/ButtonPopup.vue';
import LogoTransition from '@/components/otherComponents/LogoTransition.vue';
import { ACTION } from '@/store/ACTION';

export default Vue.extend({
  name: 'StartFreeSpinOtherGame',
  components: { ButtonPopup, LogoTransition },
  props: {
    closing: Boolean
  },
  computed: {
    ...mapGetters([
      'getLinkGame',
      'getLinkGameTournament',
      'getNameGameAchievement',
      'getTournamentFreeSpinGameName',
      'isAchievementBG',
      'isAchievementFS',
      'isAchievementPrizeGame'
    ]),
    btnCloseText(): string {
      return <string>this.$i18n.t('free_spins_popups.ok') || '';
    },
    btnTransitionText(): string {
      return <string>this.$i18n.t('free_spins_popups.transition') || '';
    },
    gameName(): string {
      return this.getNameGameAchievement || this.getTournamentFreeSpinGameName;
    },
    linkGameTournamentOrAchievement(): string {
      return this.getLinkGame || this.getLinkGameTournament;
    },
    getPrizeGame(): string {
      switch (true) {
        case this.isAchievementBG:
          return <string>this.$i18n.t('free_spins_popups.bonus_game');
        case this.isAchievementFS:
          return <string>this.$i18n.t('free_spins_popups.free_spins_game');
        default:
          return '';
      }
    },
    getCurrentPrize(): string {
      return this.isAchievementPrizeGame ? this.getPrizeGame : <string>this.$i18n.t('free_spins_popups.free_spins');
    }
  },
  methods: {
    closePopup(): void {
      promoApp.eventEmitter.emit(ACTION.HIDE_FREESPIN_WIN_OTHER_GAME);
    },
    getOtherGame(): void {
      location.href = this.linkGameTournamentOrAchievement;
    }
  },
  watch: {
    closing: function () {
      this.closePopup();
    }
  }
});
</script>

<style scoped>
.freespins-body {
  overflow-y: auto;
  height: 66%;
  padding-right: 15px;
}

.text-freespins:last-of-type {
  margin-bottom: 10px;
}
</style>
